import { ChildTabsRenderer } from "../ChildTabsRenderer";
import { DropdownArrow, ParentAndChildTabWrapper, ParentTabWrapper, TabIconAndText } from "../Common";
import SubNavListModal from "../SubNavListModal";
import { InaccessibleTabMessage } from "../InaccessibleTabMessage";
import { ParentTabsRendererProps } from "../../Types";

export function ParentTabsRenderer(props: ParentTabsRendererProps) {
  const {
    tabState,
    navLinkData,
    expanded: isNavbarExpaneded,
    onHoverTab,
    onHoverSubTab,
    onExpandParentTab,
    anchorEl,
    setAnchorEl,
  } = props;

  const { activeTabId, activeSubTabId, activeHoveredTabId, activeHoveredSubTabId, expandedParentTabId } = tabState;
  const {
    id,
    name,
    Icon,
    subNavList = null,
    route = null,
    visible = true,
    accessable = true,
    requiredPermission,
  } = navLinkData;

  const isParentTabActive = activeTabId === id;
  const isParentTabHovered = activeHoveredTabId === id;
  const isParentTabExpanded = expandedParentTabId === id;

  const showHoverEffect = isParentTabHovered && !isParentTabActive;

  return (
    visible && 
      <ParentAndChildTabWrapper isAccessable={accessable}>
        <ParentTabWrapper
          id={id}
          route={route}
          isParentTabHovered={showHoverEffect}
          isParentTabActive={isParentTabActive}
          isParentTabExpanded={isParentTabExpanded}
          isNavbarExpanded={isNavbarExpaneded}
          subNavList={subNavList}
          onExpandParentTab={onExpandParentTab}
          onHoverTab={onHoverTab}
          setAnchorEl={setAnchorEl}
          isAccessable={accessable}
        >
          <TabIconAndText
            name={name}
            Icon={Icon}
            isParentTabActive={isParentTabActive}
            isParentTabExpanded={isParentTabExpanded}
            isNavbarExpanded={isNavbarExpaneded}
          />
          {subNavList && 
            <DropdownArrow isParentTabExpanded={isParentTabExpanded} isNavbarExpanded={isNavbarExpaneded} />
          }
          {accessable && !!subNavList && (!isParentTabExpanded || !isNavbarExpaneded) && isParentTabHovered && 
            <SubNavListModal
              subNavLinkList={subNavList || []}
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              activeSubTabId={tabState.activeSubTabId}
              isParentTabActive={isParentTabActive}
            />
          }
          {!accessable && isParentTabHovered && 
            <InaccessibleTabMessage
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              requiredPermission={requiredPermission}
            />
          }
        </ParentTabWrapper>
        {subNavList && isNavbarExpaneded && 
          <ChildTabsRenderer
            isParentTabExpanded={isParentTabExpanded}
            subNavList={subNavList}
            isParentTabActive={isParentTabActive}
            activeSubTabId={activeSubTabId}
            activeHoveredSubTabId={activeHoveredSubTabId}
            onHoverSubTab={onHoverSubTab}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
        }
      </ParentAndChildTabWrapper>
    
  );
}
